function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M36.985 0H7.963C7.155 0 6.5.655 6.5 1.926V55c0 .345.655 1 1.463 1h40.074c.808 0 1.463-.655 1.463-1V12.978c0-.696-.093-.92-.257-1.085L37.607.257A.884.884 0 0036.985 0z",
  fill: "#e9e9e0"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#d9d7ca",
  d: "M37.5.151V12h11.849z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M48.037 56H7.963A1.463 1.463 0 016.5 54.537V39h43v15.537c0 .808-.655 1.463-1.463 1.463z",
  fill: "#ce3c3b"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.246 44.168v3.172h4.211v1.121h-4.211V53h-1.668V42.924h6.303v1.244h-4.635zM25.299 42.924v8.832h4.635V53h-6.303V42.924h1.668zM31.205 53l3.527-10.063h1.627L39.859 53h-1.695l-.725-2.092h-3.787L32.914 53h-1.709zm2.83-3.199h3.008l-1.49-4.348-1.518 4.348z"
}));

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 25.5,
  cy: 16,
  r: 2,
  fill: "#c8bdb8"
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  fill: "#c8bdb8"
}, /*#__PURE__*/React.createElement("path", {
  d: "M34.985 13.929l-.707-.707C32.201 11.144 29.438 10 26.5 10s-5.701 1.144-7.778 3.222C16.644 15.299 15.5 18.062 15.5 21s1.144 5.701 3.222 7.778C20.799 30.856 23.562 32 26.5 32s5.701-1.144 7.778-3.222l.707-.707L27.914 21l7.071-7.071zm-2.867 14.103A8.928 8.928 0 0126.5 30c-2.404 0-4.664-.936-6.364-2.636S17.5 23.404 17.5 21s.936-4.664 2.636-6.364S24.096 12 26.5 12c2.067 0 4.028.692 5.618 1.968L25.086 21l7.032 7.032z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.5 20h-3a1 1 0 100 2h3a1 1 0 100-2zM41.5 20h-2a1 1 0 100 2h2a1 1 0 100-2z"
}));

var SvgFla = function SvgFla(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56 56"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
};

export default SvgFla;